import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles/main.scss';

import store from '@/Redux/configureStore';

import PageTitle from '@/Modules/pageTitle/PageTitle';

import NavigationHandler from '@/Components/NavigationHandler';
import PrivateRoute from '@/Components/PrivateRoute';
import Seo from '@/Components/Seo';

// Import route configs (keep as is for now)
import allRouters from './routes';
import accountRouters from './routes/Account';

// Lazy load layouts
const LayoutComponent = lazy(() => import('@/Components/layout/Layout'));
const AccountLayoutComponent = lazy(() => import('@/Components/layout/Account'));

// Lazy load pages
const ErrorPage = lazy(() => import('@/Pages/404'));
const HealthPage = lazy(() => import('@/Pages/health'));
const HomePage = lazy(() => import('@/Pages/index'));

const setMainRouters = ({ breadcrumb, Component }: any) => {
  let path = '';
  let breadcrumbName = '';

  breadcrumb.forEach((item: any) => {
    path += item.path;
    breadcrumbName = item.breadcrumbName;
  });

  return (
    <Route
      key={path}
      path={path}
      element={
        <PrivateRoute
          needAuth
          component={() => (
            <LayoutComponent>
              <Seo title={breadcrumbName} />
              <PageTitle title={breadcrumbName} />
              <Component />
            </LayoutComponent>
          )}
          path={path}
        />
      }
    />
  );
};

const setAccountRouters = ({ breadcrumb, needAuth, Component }: any) => {
  const { path, breadcrumbName } = breadcrumb[0];

  return (
    <Route
      key={path}
      path={path}
      element={
        <PrivateRoute
          needAuth={needAuth}
          component={() => (
            <AccountLayoutComponent>
              <Seo title={breadcrumbName} />
              <Component />
            </AccountLayoutComponent>
          )}
          path={path}
        />
      }
    />
  );
};

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <NavigationHandler />
      <Suspense fallback={<div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {allRouters.map((router) => setMainRouters(router))}
          {accountRouters.map((router) => setAccountRouters(router))}
          <Route path="/health" element={<HealthPage />} />
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </Provider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
